import { Link } from "react-router-dom";

const announcements2025Array = [
   {
    link: "/Project_Positions",
    title: "Notification for the position of Communication and Analytics Manager and Junior Multimedia Specialist - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/Project_Positions",
    title: "Notification for the position of Junior Executive (Accounts) - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/Outsourced_Positions",
    title: "Notification for the position of Project Associate and Project Assistant (Outsourced Positions) - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/Outsourced_Positions",
    title: "Shortlisted Candidates for the position of Senior Placement Officer & Junior Placement Officer (Outsourced Positions) - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/msphd-admissions",
    title: "Shortlisted Candidates List - M.S.(R)/Ph.D. January 2027 cycle - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/visvesvaraya-ph-d-admission",
    title: "Admissions are now open for Visvesvaraya Ph.D. Scheme 2026-27 - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/admissions",
    title: "Syllabus - M.S.(R)/Ph.D. January 2027 cycle - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/Outsourced_Positions",
    title: "Notification for the position of Senior Placement Officer & Junior Placement Officer (Outsourced Positions) - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/ph-d-admission",
    title: "Admissions are now open for M.S.(R)/Ph.D. January 2027 cycle - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/Project_Positions",
    title: "Notification for the position of Research Associate - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/Outsourced_Positions",
    title: "Notification for the position of AV Support Engineer & AV Support Assistant (Outsourced Positions) - Click here",
    modal: false,
    blink: false,
  },
  {
    link: "/recruitment",
    title: "Advertisement for Non-Teaching Staff Positions (Regular) - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "https://files.iittp.ac.in/2026/latest_news/Executive_M.Tech._in_Intelligent_Manufacturing_Systems.pdf",
    title: "Executive M.Tech. in Intelligent Manufacturing Systems - Department of Mechanical Engineering, IIT Tirupati - Click here",
    modal: false,
    blink: false,
  },
  {
    link: "https://iittp.ac.in/convocation/",
    title: "8th Convocation - 22-08-2026 - Click here",
    modal: false,
    blink: false,
  },
  {
    link: "/Outsourced_Positions",
    title:
      "Selected candidates list for the post of Manager Outsourced Position at IIT Tirupati - Click here",
    modal: false,
    blink: false,
  },
 
  {
    link: "https://files.iittp.ac.in/pdfs/btech/2026/B.tech_Orientation_Program_2026_July.pdf",
    title: "Orientation Program of B.Tech. - 27-07-2026 - Click here",
    modal: false,
    blink: false,
  },
  {
    link: "https://files.iittp.ac.in/pdfs/mtech/2026/Orientation_MTech_Msc_MPP_Jul_2026.pdf",
    title: "Orientation Program of M.Tech./M.Sc./MPP- 29-07-2026 - Click here",
    modal: false,
    blink: false,
  },

  {
    link: "/Outsourced_Positions",
    title: "Notification for the position of Assistant Manager, Senior Executive, Junior Executive, Institute Counsellor, and Psychiatric Nurse (Outsourced Positions)",
    modal: false,
  },

   {
    link: "https://files.iittp.ac.in/pdfs/msphd/admissions/2026/jul/Orientation_Programme_MS(R)_PhD_Jul_2026.pdf",
    title: "Orientation Program of MS(R)/PhD - 17-07-2026 - Click here",
    modal: false,
    blink: false,
  },
  
  
  {
    link: "/information_for_btech_students",
    title: "Information for B.Tech. 2026 Batch Students - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "https://scholarships.gov.in/All-Scholarships",
    title:"Inviting Fresh & Renewal applications under the 'National Scholarship for Top Class Education for SC, ST, OBC, EBC, DNT, PwD  Students' for the year AY 2026-2027 - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/Outsourced_Positions",
    title:
      "Walk in interview advertisement and application form for the post of Car Driver (on contract) - Click here",
    
    modal: false,
  }, 
   {
    link: "https://files.iittp.ac.in/images/IDDD_Flyer_26.png",
    title:
      "Interdisciplinary Dual Degree in Data Science - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/openhouse",
    title:
      "Open House - An Interactive Session for Prospective Students 2026 - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "https://cdo.iittp.ac.in/aest.html",
    title:
      "eCampus M.Tech. in Advanced Energy Storage Technology - Last date of registration is extended to 14th June 2026",
    modal: false,
    blink: true,
  },
  {
    link: "/msphd-admissions",
    title:
      "List of second phase of interviews shortlist for Track-1 candidates for Master of Public Policy (MPP) admissions 2026 - Click here",
    modal: false,
     blink: true,
  },
  {
    link: "https://files.iittp.ac.in/pdfs/mtech/2026/M.Tech.Self-Sponsored_Flyer.pdf",
    title:
      "M.Tech Self Sponsored Programme Flyer 2026 - Click here",
    modal: false,
    blink: true,
  },
  
  {
    link: "/facultyrecruitment",
    title:
      "Faculty Recruitment Advertisement 2026 - The last date for receiving the applications has been extended to 29.05.2026 (up to 5.00 PM) - Click here",
    modal: false,
    blink: true,
  },
   {
    link: "/m-tech-self-sponsored-admission",
    title:
      "Admissions are now open for M.Tech. Self-Sponsored Programme 2026 - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "https://cdo.iittp.ac.in/aest.html",
    title:
      "Applications are open for the M.Tech in Advanced Energy Storage Technology program for the year 2026 - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/Outsourced_Positions",
    title:
      "The advertisement and application form for the post of Manager (on contract) Outsourced Position at IIT Tirupati - Click here",
    
    modal: false,
    blink: true,
  },
  {
    link: "/msphd-admissions",
    title:
      "List of provisionally selected candidates for M.S.(R) and Ph.D. Admissions (July 2026) semester across various departments - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/Project_Positions",
    title:
      "Selected candidates list for the Project Manager position in CSRC - Click here",
    modal: false,
    blink: true,
  },
   {
    link: "/msphd-admissions",
    title:
      "List of provisionally shortlisted candidates for Master of Public Policy (MPP) admissions 2026 - Click here",
    modal: false,
     blink: true,
  },
  {
    link: "/msphd-admissions",
    title:
      "List of provisionally shortlisted candidates for Written Test / Interview - M.S.(R) and Ph.D. Admissions (July 2026) - Click here",
    modal: false,
    blink: true,
  },
   {
    link: "/Project_Positions",
    title:
      "Selected candidates list for the Junior Executive positions in the CSRC section (On contract basis) - Click here",
    modal: false,
  },
   {
    link: "/Outsourced_Positions",
    title:
      "Selected candidates list for the post of Night Duty Doctors, Nursing Practitioner, Nursing Assistant, Ambulance Driver and Car Driver (on contract) - Click here",
    
    modal: false,
  },
  {
    link: "/Interns_and_Apprentice",
    title:
      "Selected Students List for Summer Internship 2026 at IIT Tirupati - Click here",
    blink: true,
    modal: false,
  },
  {
    link: "/Outsourced_Positions",
    title:
      "The Selected candidates list for the post of Institute Counsellor (on contract) Outsourced Position at IIT Tirupati - Click here",
    
    modal: false,
  },
  {
    link: "/Interns_and_Apprentice",
    title:
      "Selected candidates list for the 1-year Apprenticeship Training Programme for Graduate / Diploma under NATS - Click here",
    modal: false,
    blink: true,
  },
   
  {
    link: "/Project_Positions",
    title:
      "Advertisement for the Junior Research Fellow (JRF) positions in CSRC section (On contract basis)",
    modal: false,
  },
   
   {
    link: "/msphd-admissions",
    title:
      "Syllabus for M.S.(R) & Ph.D Admissions (July 2026)  - Click here",
    modal: false,
    blink: true,
  },
  {
    link: "/m-tech-admission",
    title:
      "M.Tech. 2026 Admissions open - Click here for more details and to apply",
    modal: false,
    blink: true,
  },
  {
    link: "/master-of-public-policy-mpp-admission",
    title:
      "MPP 2026 Admissions open - Click here for more details and to apply",
    modal: false,
    blink: true,
  },
  {
    link: "/admissions",
    title:
      "M.S.(R) & Ph.D. Admissions open for the July-26 cycle - click here for more details and to apply.",
    modal: false,
    blink: true,
  },
  {
    link: "/Project_Positions",
    title:
      "Advertisement for the Post-Doctoral Fellow position in the Department of Civil and Environmental Engineering under CSRC Project (On contract basis)",
    modal: false,
  },
  {
    link: "/Outsourced_Positions",
    title:
      "Walk in interview advertisement and application form for the post of Night Duty Doctors, Nursing Practitioner, Nursing Assistant, Ambulance Driver and Car Driver (on contract) - Click here",
    
    modal: false,
  }, 
  {
    link: "/Interns_and_Apprentice",
    title:
      "Advertisement for 1-year Apprenticeship Training Programme for Graduate/Diploma under NATS",
    modal: false,
    blink: true,
  },
  {
    link: "/Outsourced_Positions",
    title:
      "The Shortlisted candidates list for the post of Institute Counsellor (on contract) Outsourced Position at IIT Tirupati - Click here",
    
    modal: false,
  },
  {
    link: "/Outsourced_Positions",
    title:
      "Selected candidate list for the position of of Internal Audit Officer (on contract) Outsourced Position - Click here",
    
    modal: false,
  },
  {
    link: "/Project_Positions",
    title:
      "Advertisement for the Project Executive positions in CSRC section (On contract basis)",
    modal: false,
  },
   {
    link: "/Project_Positions",
    title:
      "Advertisement for the Project Associate I position in the Department of Physics under CSRC",
    modal: false,
  },
   {
    link: "/Outsourced_Positions",
    title:
      "Selected candidates list for the position of Ambulance Driver (Outsourced Positions)",
    
    modal: false,
  },
  {
    link: "/Project_Positions",
    title:
      "Advertisement for the Chief Manager & Project Manager position in CSRC",
    modal: false,
  },
   {
    link: "/Interns_and_Apprentice",
    title:
      "Notification for two months of Summer Internship at IIT Tirupati - Click here",

    modal: false,
  },
  {
    link: "/Project_Positions",
    title:
      "Advertisement for the Research Associate III (RA III) position in the Department of Physics under CSRC",
    modal: false,
  },
  {
    link: "/Outsourced_Positions",
    title:
      "The advertisement and application form for the post of Institute Counsellor and Psychiatric Nurse (on contract) Outsourced Position at IIT Tirupati - Click here",
    
    modal: false,
  },
  {
    link: "/Outsourced_Positions",
    title:
      "The advertisement and application form for the post of Internal Audit Officer (on contract) Outsourced Position at IIT Tirupati - Click here",
    
    modal: false,
  },
  {
    link: "/Project_Positions",
    title:
      "Selected candidates list for the position of Project Associate I and Principal Project Scientist - Department of Physics under the CSRC.",

    modal: false,
  },
  {
    link: "/Project_Positions",
    title:
      "Selected candidates list for the position of Research Associate (RA-I) and Junior Research Fellow - Department of Chemical Engineering under the CSRC.",

    modal: false,
  },
  {
    link: "/Interns_and_Apprentice",
    title:
      "Selected candidates list for the position of Junior Library Executive - Library Section.",

    modal: false,
  },
  {
    link: "/Project_Positions",
    title:
      "Advertisement for the Junior Research Fellow, Project Associate and Junior Research Fellow positions in the Department of Chemical Engineering and Civil & Environmental Engineering under CSRC",

    modal: false,
  },
  {
    link: "/Project_Positions",
    title:
      "Selected candidates list for the position of Program Manager (CDP Vertical) - Office of Competency Development and Outreach (CDO).",

    modal: false,
  },
   {
    link: "/Project_Positions",
    title:
      "Advertisement for the Junior Research Fellow and Senior Project Associate / Project Scientist I positions in the Department of Civil & Environmental Engineering under CSRC",

    modal: false,
  },
  {
    link: "/Project_Positions",
    title:
      "Shortlisted candidates list for the position of Program Manager (CDP Vertical) - Office of Competency Development and Outreach (CDO).",

    modal: false,
  },
   {
    link: "/Outsourced_Positions",
    title:
      "Shortlisted candidates list for the position of Nursing Practitioner, Nursing Assistant & Ambulance Driver (Outsourced Positions)",
    
    modal: false,
  },
  
];

export default announcements2025Array;
